import List from "./List";

const routes = [
    {
        path: 'products',
        element: <List />
    }
]
export default routes;